// extracted by mini-css-extract-plugin
module.exports = {"iframeContainer":"Youtube_iframeContainer__JGdKV"};